import React from 'react'

const Services = () => {
  return (
    <div className='services'>
         <h5 className="header text-center">  Services  </h5>
         <div className="row w-100 mx-auto px-4">
             <div className="col-12 col-sm-6 col-md-4 pt-2 ">
                   <div className="wrapper d-block mx-auto border pt-2">
                        <span className="fas fa-code d-block text-center"></span>
                        <h6 className='text-center mt-1'>  Web Development </h6>
                        <p className='text-center'> 
                             Implementation of psd or figma design into a
                             live website with cross browser compatibility.
                         </p>
                         {/* <img src="assets/WebDevelopmentImage.jpeg" alt="logo" className='lmage mx-auto mr- mb-2'/>  */}
                       
                   </div>
             </div>
             <div className="col-12 col-sm-6 col-md-4 pt-2">
                   <div className="wrapper d-block mx-auto border pt-2">
                        <span className="fas fa-laptop d-block text-center"></span>
                        <h6 className='text-center mt-1'>  Responsive Design </h6>
                        <p className='text-center'> 
                             Design that aims to make web pages render well on
                             verity of devices mobile tablet and desktop.
                         </p>
                   </div>
             </div>
             <div className="col-12 col-sm-6 col-md-4 pt-2">
                   <div className="wrapper d-block mx-auto border pt-2">
                        <span className="fas fa-laptop d-block text-center"></span>
                        <h6 className='text-center mt-1'>  Wordpress Design </h6>
                        <p className='text-center'> 
                             Design and Developement of Website using Wordpress
                         with plugins like Elementor etc.
                         </p>
                   </div>
             </div>
             {/* <div className="col-12 col-sm-6 col-md-4 pt-2 mt-2">
                   <div className="wrapper d-block mx-auto border pt-2">
                        <span className="fas fa-laptop d-block text-center"></span>
                        <h6 className='text-center mt-1'>  App Development </h6>
                        <p className='text-center'> 
                        Implementation of psd or figma design into a
                             live Application.
                         </p>
                   </div>
             </div>
             <div className="col-12 col-sm-6 col-md-4 pt-2 mt-2">
                   <div className="wrapper d-block mx-auto border pt-2">
                        <span className="fas fa-laptop d-block text-center"></span>
                        <h6 className='text-center mt-1'>  Wordpress Design </h6>
                        <p className='text-center'> 
                             Design and Developement of Website using Wordpress
                         with plugins like Elementor etc.
                         </p>
                   </div>
             </div>
             <div className="col-12 col-sm-6 col-md-4 pt-2 mt-2">
                   <div className="wrapper d-block mx-auto border pt-2">
                        <span className="fas fa-laptop d-block text-center"></span>
                        <h6 className='text-center mt-1'>  Wordpress Design </h6>
                        <p className='text-center'> 
                             Design and Developement of Website using Wordpress
                         with plugins like Elementor etc.
                         </p>
                   </div>
             </div> */}
                         
         </div>
    </div>
  )
}

export default Services